import { Controller } from "@hotwired/stimulus"

// Primer Brand's Tooltip, on the native popover API.
//
// The popover lives in the browser's top layer, so it is positioned against
// the viewport and needs the page scroll added back. Closing waits a beat so
// the pointer can travel from the trigger onto the tooltip itself.
const CLOSE_DELAY = 200
const OFFSET = 8

export default class extends Controller {
  static targets = ["trigger", "tooltip"]
  static values = { direction: { type: String, default: "s" }, type: { type: String, default: "description" } }

  connect() {
    const interactive = this.triggerTarget.querySelector("a[href], button, summary, select, input, textarea, [role='button']")
    const target = interactive || this.triggerTarget
    const attribute = this.typeValue === "label" ? "aria-labelledby" : "aria-describedby"
    target.setAttribute(attribute, this.tooltipTarget.id)
  }

  disconnect() {
    clearTimeout(this.closeTimer)
  }

  open() {
    clearTimeout(this.closeTimer)
    if (this.tooltipTarget.matches(":popover-open")) return

    this.tooltipTarget.showPopover()
    this.position()
  }

  close() {
    this.closeTimer = setTimeout(() => this.hide(), CLOSE_DELAY)
  }

  hide() {
    clearTimeout(this.closeTimer)
    if (this.tooltipTarget.matches(":popover-open")) this.tooltipTarget.hidePopover()
  }

  position() {
    const anchor = this.triggerTarget.getBoundingClientRect()
    const tip = this.tooltipTarget.getBoundingClientRect()
    let top, left

    switch (this.directionValue) {
      case "n":
        top = anchor.top - tip.height - OFFSET
        left = anchor.left + (anchor.width - tip.width) / 2
        break
      case "e":
        top = anchor.top + (anchor.height - tip.height) / 2
        left = anchor.right + OFFSET
        break
      case "w":
        top = anchor.top + (anchor.height - tip.height) / 2
        left = anchor.left - tip.width - OFFSET
        break
      default:
        top = anchor.bottom + OFFSET
        left = anchor.left + (anchor.width - tip.width) / 2
    }

    this.tooltipTarget.style.top = `${top + window.scrollY}px`
    this.tooltipTarget.style.left = `${left + window.scrollX}px`
  }
}
